import Layout from '@/layout'

const ProjectManageRouter = {
  path: '/projectManage',
  component: Layout,
  redirect: 'noredirect',
  name: 'ProjectManage',
  meta: {
    title: 'ProjectManage',
    icon: 'daohang-ziliaoguanli'
    // roles: ['subsystem_SEAEXPORT']
  },
  children: [
    {
      path: 'Project',
      component: () => import('@/views/cargo/v0/ProjectManage/project'),
      name: 'Project',
      meta: { title: 'project' },
      roles: ['module_ProjectModule']
    }
  ]
}

export default ProjectManageRouter
